export default __webpack_public_path__ + "static/media/access_denied.86dad45c.jpg";